import { Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import "./PlatformDropdown.css";
import { useNavigate } from "react-router-dom";

import { useSelectedProductStore } from "../store/select-product-store";
import { LlmWhispererLogo } from "../assets/llmWhisperer";
// import { APIHubDarkLogo } from "../assets/verticals/index";
import { UnstractBlackLogo } from "../../assets/index";
import { useSessionStore } from "../../store/session-store";

const PlatformDropdown = () => {
  const { setSelectedProduct, selectedProduct } = useSelectedProductStore();
  const { sessionDetails, setSessionDetails } = useSessionStore();
  const navigate = useNavigate();

  const menu = [
    {
      key: "1",
      label: (
        <div className="logo-label">
          <UnstractBlackLogo className="unstract-logo" />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="logo-label">
          <LlmWhispererLogo />
        </div>
      ),
    },
    // {
    //   key: "3",
    //   label: (
    //     <div className="logo-label">
    //       <APIHubDarkLogo />
    //     </div>
    //   ),
    // },
  ];

  const onClick = ({ key }) => {
    const productMap = {
      1: "unstract",
      2: "llm-whisperer",
      // 3: "verticals",
    };

    const newProduct = productMap[key];
    if (selectedProduct !== newProduct) {
      setSelectedProduct(newProduct);
      setSessionDetails({ ...sessionDetails, isLoggedIn: false });
      navigate("/");
    }
  };

  return (
    <Dropdown
      menu={{
        items: menu,
        onClick,
        selectable: true,
        defaultSelectedKeys: [
          selectedProduct === "unstract"
            ? "1"
            : selectedProduct === "llm-whisperer",
        ],
      }}
      trigger={["click"]}
    >
      <DownOutlined className="switcher-dropdown" />
    </Dropdown>
  );
};

export { PlatformDropdown };
